import { render } from "./OcrLayout.vue?vue&type=template&id=03e5378a"
import script from "./OcrLayout.vue?vue&type=script&lang=js"
export * from "./OcrLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__